import flashMessenger from './FlashMessenger';
import messageModel from '../model/MessageModel';
import config from './Config';
import router from '../router';
import crApi from "./CrApi";
import securityService from "./SecurityService";

class ExternalAccountHelper {
    public modalVisible = false;
    public modalFTPVisible = false;
    public modalSFTPVisible = false;
    public externalAccountId = '';
    public showAllOptions = false;
    public showFtpErr = false;
    public isProcessing = false;
    public ftpServerParse = '';
    public ftpUser = '';
    public ftpPassword = '';
    public ftpPort = '';
    public ftpServer = '';
    public showSftpErr  = false;
    public sftpKey = '';
    public ftpSuccess = false;
    public qType = null;
    public modalS3Visible = false;
    public s3Success = false;
    public showS3Err = false;
    public identityPoolId = '';
    public bucketname = '';
    public region = '';
    public s3AuthType = '';
    public accessKey = '';
    public secretToken = '';
    public modalGoogleVisible = false;
    public googleSuccess = false;
    public showGoogle = false;
    public showDropbox = false;
    public showBox = false;
    public showSftp = false;
    public ftpType = 'ftp';
    public showSftpKey = false;
    public sftpSuccess = false;
    public sftpAuthType = 'password';
    public sftpKeyPhrase = '';
    public sftpPassword = '';
    public regionList = [
        {id : 'us-east-2', name: 'US East (Ohio)' },
        {id : 'us-east-1', name: 'US East (N. Virginia)' },
        {id : 'us-west-1', name: 'US West (N. California)' },
        {id : 'us-west-2', name: 'US West (Oregon)' },
        {id : 'af-south-1', name: 'Africa (Cape Town)' },
        {id : 'ap-east-1', name: 'Asia Pacific (Hong Kong)' },
        {id : 'ap-south-1', name: 'Asia Pacific (Mumbai)' },
        {id : 'ap-northeast-3', name: 'Asia Pacific (Osaka)' },
        {id : 'ap-northeast-2', name: 'Asia Pacific (Seoul)' },
        {id : 'ap-southeast-1', name: 'Asia Pacific (Singapore)' },
        {id : 'ap-southeast-2', name: 'Asia Pacific (Sydney)' },
        {id : 'ap-northeast-1', name: 'Asia Pacific (Tokyo)' },
        {id : 'ca-central-1', name: 'Canada (Central)' },
        {id : 'cn-north-1', name: 'China (Beijing)' },
        {id : 'cn-northwest-1', name: 'China (Ningxia)' },
        {id : 'eu-central-1', name: 'Europe (Frankfurt)' },
        {id : 'eu-west-1', name: 'Europe (Ireland)' },
        {id : 'eu-west-2', name: 'Europe (London)' },
        {id : 'eu-south-1', name: 'Europe (Milan)' },
        {id : 'eu-west-3', name: 'Europe (Paris)' },
        {id : 'eu-north-1', name: 'Europe (Stockholm)' },
        {id : 'me-south-1', name: 'Middle East (Bahrain)' },
        {id : 'sa-east-1', name: 'South America (São Paulo)'}
    ];
    public edit(externalAccount) {
        this.modalVisible = true;
    }

    public create(type, qtype = null) {
        if (type == 'all') {
            this.showAllOptions = true;
            this.showGoogle = true;
            this.showDropbox = true;
            this.showBox = true;
            this.showSftp = true;
        }
        if (type == 'google') {
            this.showDropbox = false;
            this.showGoogle = true;
            this.showBox = false;
            this.showSftp = false;
            this.showAllOptions = false;
        }
        if (type == 'dropbox') {
            this.showGoogle = false;
            this.showDropbox = true;
            this.showBox = false;
            this.showSftp = false;
            this.showAllOptions = false;
        }
        if (type == 'box') {
            this.showGoogle = false;
            this.showDropbox = false;
            this.showBox = true;
            this.showSftp = false;
        }

        if (type == 'sftpkey') {
            this.showGoogle = false;
            this.showDropbox = false;
            this.showBox = false;
            this.showSftpKey = true;
        }
        if (qtype) {
            this.qType = qtype;
        }
        this.modalVisible = true;
        this.modalFTPVisible = false;
    }

    public createFTP() {
        this.clearFTP();
        this.modalFTPVisible = true;
        this.modalVisible = false;
        this.ftpSuccess = false;

    }
    public createSFTP() {
        this.clearSFTP();
        this.modalSFTPVisible = true;
        this.modalVisible = false;
        this.sftpSuccess = false;
    }
    public createS3() {
        this.clearS3();
        this.modalS3Visible = true;
        this.modalVisible = false;
        this.s3Success = false;
    }
    public createGoogle() {
        this.clearGoogle();
        this.modalGoogleVisible = true;
        this.modalVisible = false;
        this.googleSuccess = false;
    }


    public editFTP(externalAccount) {
        this.clearFTP();
        this.externalAccountId = externalAccount['accountId'];
        const externalAccountConfig = externalAccount.config;
        this.ftpServerParse = externalAccountConfig.ftp_host;
        this.ftpUser = externalAccountConfig.ftp_user;
        this.ftpPassword = externalAccountConfig.ftp_password;
        this.ftpPort = externalAccountConfig.ftp_port;
        this.modalFTPVisible = true;
        this.modalVisible = false;
        this.ftpSuccess = false;
    }
    public editSFTP(externalAccount) {
        this.clearSFTP();
        this.externalAccountId = externalAccount['accountId'];
        const externalAccountConfig = externalAccount.config;
        this.sftpAuthType = externalAccountConfig.sftp_auth_type;
        this.ftpServerParse = externalAccountConfig.sftp_server;
        this.ftpUser = externalAccountConfig.sftp_username;
        this.sftpKey = externalAccountConfig.sftp_key;
        this.sftpPassword = externalAccountConfig.sftp_password;
        this.ftpPort = externalAccountConfig.sftp_port;
        this.sftpKeyPhrase = externalAccountConfig.sftp_key_phrase;
        this.modalSFTPVisible = true;
        this.modalVisible = false;
        this.sftpSuccess = false;
    }
    public clearSFTP() {
        this.isProcessing = false;
        this.ftpServerParse = null;
        this.ftpServer = null;
        this.ftpUser = null;
        this.sftpKey = null;
        this.ftpPort = null;
        this.sftpKeyPhrase = null;
        this.sftpPassword = null;
        this.externalAccountId = '';
    }
    public clearFTP() {
        this.isProcessing = false;
        this.ftpServerParse = null;
        this.ftpServer = null;
        this.ftpUser = null;
        this.ftpPassword = null;
        this.ftpPort = null;
        this.externalAccountId = '';
    }
    public clearS3() {
        this.isProcessing = false;
        this.identityPoolId = null;
        this.externalAccountId = '';
        this.region = '';
        this.bucketname = '';
        this.s3AuthType = 'pool_id';
        this.secretToken = '';
        this.accessKey = '';
    }
    public clearGoogle() {
        this.isProcessing = false;
        this.identityPoolId = null;
        this.externalAccountId = '';
        this.region = '';
        this.bucketname = '';
        this.s3AuthType = 'pool_id';
        this.secretToken = '';
        this.accessKey = '';
    }
    public async doCreateDropbox() {
        let params = {
            website_token : securityService.getToken(),
            type : 'dropbox'
        };
        let externalAccount = await crApi.requestV2('external_account/create/',params);

        let externalAccountId = externalAccount.accountId;
        let authParam = {
            website_token : securityService.getToken(),
            externalAccountId :externalAccountId
        };
        let response = await crApi.requestV2('external_account/dropbox_auth_url/',authParam);

        const authUrl = response.authUrl;
        let qParams = {'return_state': router.currentRoute.value['name'], 'return_state_params': router.currentRoute.value['params'], 'return_state_query': router.currentRoute.value['query'], 'externalAccountId': externalAccountId};
        if (this.qType) {
            qParams['qtype'] = this.qType
        }
        const state = encodeURIComponent(JSON.stringify(qParams));

        // @ts-ignore
        window.location = authUrl+'&state='+state;
    }
    public async doCreateGoogleDrive() {
        let params = {
            website_token : securityService.getToken(),
            type : 'google'
        };
        let externalAccount = await crApi.requestV2('external_account/create/',params);
        let externalAccountId = externalAccount.accountId;
        let authParam = {
            website_token : securityService.getToken(),
            externalAccountId :externalAccountId
        };
        let response = await crApi.requestV2('external_account/google_auth_url/',authParam);
        const authUrl = response.authUrl;
        let  state ='return_state='+router.currentRoute.value['name']+'&return_state_params='+JSON.stringify(router.currentRoute.value['params'])+'&return_state_query='+JSON.stringify(router.currentRoute.value['query'])+'&externalAccountId='+externalAccountId;
        if (this.qType) {
            state += '&qtype='+this.qType
        }
        state += '&rnd='+Math.random();

        state =  encodeURIComponent(state);
        // @ts-ignore
        window.location = authUrl+'&state='+state;
    }
    public async doCreateBox() {
        let params = {
            website_token : securityService.getToken(),
            type : 'box'
        };
        let externalAccount = await crApi.requestV2('external_account/create/',params);

        let externalAccountId = externalAccount.accountId;
        let authParam = {
            website_token : securityService.getToken(),
            externalAccountId :externalAccountId
        };
        let response = await crApi.requestV2('external_account/box_auth_url/',authParam);

        const authUrl = response.authUrl;
        let  state ='return_state='+router.currentRoute.value['name']+'&return_state_params='+JSON.stringify(router.currentRoute.value['params'])+'&return_state_query='+JSON.stringify(router.currentRoute.value['query'])+'&externalAccountId='+externalAccountId;
        if (this.qType) {
            state += '&qtype='+this.qType
        }
        state += '&rnd='+Math.random();

        state =  encodeURIComponent(state);
        // @ts-ignore
        window.location = authUrl+'&state='+state;
    }

    public getFTPParams() {
        if (typeof this.ftpServerParse === 'undefined' || !this.ftpServerParse || this.ftpServerParse.trim() == '') {
            messageModel.getById('MISSING_FTP_SERVER', {}).then((message) => {
                document.getElementById('showFtpErr').innerHTML = message.text;
                this.showFtpErr = true;
                // externalAccountHelper.ftpServerParse = '';
                setTimeout(() => {
                    this.showFtpErr = false;
                }, 5000);
            });
            return false;
        }
        if (!this.ftpServer && this.ftpServerParse) {
            this.ftpServer = this.ftpServerParse.replace(/^s?ftp?:\/\//,'');
        }

        if (typeof this.ftpUser == 'undefined' ||  !this.ftpUser || this.ftpUser.trim() == '') {
            messageModel.getById('MISSING_FTP_USERNAME', {}).then((message) => {
                document.getElementById('showFtpErr').innerHTML = message.text;
                this.showFtpErr = true;
                // externalAccountHelper.ftpServerParse = '';
                setTimeout(() => {
                    this.showFtpErr = false;
                }, 5000);
            });
            return false;
        }
        if (typeof this.ftpPassword == 'undefined' ||  !this.ftpPassword || this.ftpPassword.trim() == '') {
            messageModel.getById('MISSING_FTP_PASSWORD', {}).then((message) => {
                document.getElementById('showFtpErr').innerHTML = message.text;
                this.showFtpErr = true;
                // externalAccountHelper.ftpServerParse = '';
                setTimeout(() => {
                    this.showFtpErr = false;
                }, 5000);
            });
            return false;
        }
        const ftpParams = {
            ftp_host: this.ftpServer,
            ftp_user: this.ftpUser,
            ftp_password: this.ftpPassword,
            ftp_port: this.ftpPort,
        };
        let name = this.ftpUser + '@' + this.ftpServer;
        if (this.ftpPort && this.ftpPort != '') {
            name += ':' + this.ftpPort;
        }

        const params = {
            config : ftpParams,
            name : name,
            website_token : securityService.getToken()
        };

        return params;
    }

    public getSFTPParams() {
        if (typeof this.ftpServerParse === 'undefined' || !this.ftpServerParse || this.ftpServerParse.trim() == '') {
            messageModel.getById('MISSING_FTP_SERVER', {}).then((message) => {
                document.getElementById('showSftpErr').innerHTML = message.text;
                this.showSftpErr = true;
                // externalAccountHelper.ftpServerParse = '';
                setTimeout(() => {
                    this.showSftpErr = false;
                }, 5000);
            });
            return false;
        }
        if (typeof this.ftpUser == 'undefined' ||  !this.ftpUser || this.ftpUser.trim() == '') {
            messageModel.getById('MISSING_FTP_USERNAME', {}).then((message) => {
                document.getElementById('showSftpErr').innerHTML = message.text;
                this.showSftpErr = true;
                // externalAccountHelper.ftpServerParse = '';
                setTimeout(() => {
                    this.showSftpErr = false;
                }, 5000);
            });
            return false;
        }
        if (this.sftpAuthType === 'key') {
            if (typeof this.sftpKey == 'undefined' || !this.sftpKey || this.sftpKey.trim() == '') {
                messageModel.getById('ERR_PRIVATE_KEY', {}).then((message) => {
                    document.getElementById('showSftpErr').innerHTML = message.text;
                    this.showSftpErr = true;
                    // externalAccountHelper.ftpServerParse = '';
                    setTimeout(() => {
                        this.showSftpErr = false;
                    }, 5000);
                });
                return false;
            }
        }
        if (this.sftpAuthType === 'password') {
            if (typeof this.sftpPassword == 'undefined' || !this.sftpPassword || this.sftpPassword.trim() == '') {
                messageModel.getById('MISSING_SFTP_PASSWORD', {}).then((message) => {
                    document.getElementById('showSftpErr').innerHTML = message.text;
                    this.showSftpErr = true;
                    // externalAccountHelper.ftpServerParse = '';
                    setTimeout(() => {
                        this.showSftpErr = false;
                    }, 5000);
                });
                return false;
            }
        }
        const ftpParams = {
            sftp_server: this.ftpServerParse,
            sftp_username: this.ftpUser,
            sftp_port: this.ftpPort,
            sftp_auth_type : this.sftpAuthType,
        };
        if (this.sftpAuthType === 'password') {
            ftpParams['sftp_password'] = this.sftpPassword;
        }
        if (this.sftpAuthType === 'key') {
            ftpParams['sftp_key'] = this.sftpKey;
            ftpParams['sftp_key_phrase'] = this.sftpKeyPhrase;
        }
        let name = this.ftpUser + '@' + this.ftpServerParse;
        if (this.ftpPort && this.ftpPort != '') {
            name += ':' + this.ftpPort;
        }
        const params = {
            config : ftpParams,
            name : name,
            website_token : securityService.getToken()
        };

        return params;
    }

    public async doCreateFtp() {
        if (this.isProcessing) {
            return;
        }
        this.isProcessing = true;
        const params = this.getFTPParams();
        if (params) {
            params['type'] = 'ftp';
            let response = await crApi.requestV2('external_account/create/', params);
            if (response.status == 1) {
                this.externalAccountId = response.accountId;
                this.modalFTPVisible = false;
                this.ftpSuccess = true;
                this.isProcessing = false;
                flashMessenger.toastById('EXT_ACC_CREATED', 'success');
                if(router.currentRoute.value['name'] === 'account.externalaccount.filestorage') {
                    router.push({name: 'account.externalaccount.filestorage', query: {id: response.accountId}});
                }
            } else {
                flashMessenger.toastById(response.error, 'danger');
                this.isProcessing = false;
            }

        } else {
            this.isProcessing = false;
            return false;
        }
    }
    public async doCreateSftp() {
        if (this.isProcessing) {
            return;
        }
        this.isProcessing = true;
        const params = this.getSFTPParams();
        if (params) {
            params['type'] = 'sftp';

            let response = await crApi.requestV2('external_account/create/', params);
            if (response.status == 1) {
                this.externalAccountId = response.accountId;
                this.modalSFTPVisible = false;
                this.sftpSuccess = true;
                this.isProcessing = false;
                flashMessenger.toastById('EXT_ACC_CREATED', 'success');
                if(router.currentRoute.value['name'] === 'account.externalaccount.filestorage') {
                    router.push({name: 'account.externalaccount.filestorage', query: {id: response.accountId}});
                }
            } else {
                flashMessenger.toastById(response.error, 'danger');
                this.isProcessing = false;
            }

        } else {
            this.isProcessing = false;
            return false;
        }
    }

    public async doEditFtp() {
        if (this.isProcessing) {
            return;
        }
        this.isProcessing = true;
        const params = this.getFTPParams();
        if (params) {
            params['externalAccountId'] = this.externalAccountId;
            let response = await crApi.requestV2('external_account/update/', params);
            if (response.status == 1) {
                this.externalAccountId = response.accountId;
                this.modalFTPVisible = false;
                this.ftpSuccess = true;
                this.isProcessing = false;
                flashMessenger.toastById('EXT_ACC_UPDATED', 'success');
                router.go(0);
            } else {
                flashMessenger.toastById(response.error, 'danger');
                this.isProcessing = false;
            }
        } else {
            this.isProcessing = false;
            return false;
        }
    }
    public async doEditSftp() {
        if (this.isProcessing) {
            return;
        }
        this.isProcessing = true;
        const params = this.getSFTPParams();
        if (params) {
            params['externalAccountId'] = this.externalAccountId;
            let response = await crApi.requestV2('external_account/update/', params);
            if (response.status == 1) {
                this.externalAccountId = response.accountId;
                this.modalSFTPVisible = false;
                this.sftpSuccess = true;
                this.isProcessing = false;
                flashMessenger.toastById('EXT_ACC_UPDATED', 'success');
                if(router.currentRoute.value['name'] === 'account.externalaccount.filestorage') {
                    router.go(0)
                    //router.push({name: 'account.externalaccount', query: {id: this.externalAccountId}});
                }
            } else {
                flashMessenger.toastById(response.error, 'danger');
                this.isProcessing = false;
            }


        } else {
            this.isProcessing = false;
            return false;
        }
    }
    public getS3Params() {
        if (this.s3AuthType == 'pool_id') {
            if (typeof this.identityPoolId === 'undefined' || !this.identityPoolId || this.identityPoolId.trim() == '') {
                messageModel.getById('ERR_POOL_ID', {}).then((message) => {
                    document.getElementById('showS3Err').innerHTML = message.text;
                    this.showS3Err = true;
                    // externalAccountHelper.ftpServerParse = '';
                    setTimeout(() => {
                        this.showS3Err = false;
                    }, 5000);
                });
                return false;
            }
        } else {
            if (typeof this.accessKey === 'undefined' || !this.accessKey || this.accessKey.trim() == '') {
                messageModel.getById('ERR_S3_KEY', {}).then((message) => {
                    document.getElementById('showS3Err').innerHTML = message.text;
                    this.showS3Err = true;
                    // externalAccountHelper.ftpServerParse = '';
                    setTimeout(() => {
                        this.showS3Err = false;
                    }, 5000);
                });
                return false;
            }
            if (typeof this.secretToken === 'undefined' || !this.secretToken || this.secretToken.trim() == '') {
                messageModel.getById('ERR_S3_TOKEN', {}).then((message) => {
                    document.getElementById('showS3Err').innerHTML = message.text;
                    this.showS3Err = true;
                    // externalAccountHelper.ftpServerParse = '';
                    setTimeout(() => {
                        this.showS3Err = false;
                    }, 5000);
                });
                return false;
            }
        }
        if (typeof this.region === 'undefined' || !this.region || this.region.trim() == '') {
            messageModel.getById('ERR_REGION', {}).then((message) => {
                document.getElementById('showS3Err').innerHTML = message.text;
                this.showS3Err = true;
                // externalAccountHelper.ftpServerParse = '';
                setTimeout(() => {
                    this.showS3Err = false;
                }, 5000);
            });
            return false;
        }
        if (typeof this.bucketname === 'undefined' || !this.bucketname || this.bucketname.trim() == '') {
            messageModel.getById('MISSING_S3_BUCKET', {}).then((message) => {
                document.getElementById('showS3Err').innerHTML = message.text;
                this.showS3Err = true;
                // externalAccountHelper.ftpServerParse = '';
                setTimeout(() => {
                    this.showS3Err = false;
                }, 5000);
            });
            return false;
        }
        let name = this.region+':'+this.bucketname;
        const s3Params = {
            auth_type : this.s3AuthType,
            bucket_name : this.bucketname,
            region : this.region,
            name : name
        };
        if (this.s3AuthType == 'pool_id') {
            s3Params['identity_pool_id'] = this.identityPoolId;
        } else {
            s3Params['access_key_id'] = this.accessKey;
            s3Params['secret_access_key'] = this.secretToken;
        }

        const params = {
            config : s3Params,
            name : name,
            website_token : securityService.getToken()
        };

        return params;
    }
    public async doCreateS3() {
        if (this.isProcessing) {
            return;
        }
        this.isProcessing = true;
        const params = this.getS3Params();
        if (params) {
            params['type'] = 's3';
            let response = await crApi.requestV2('external_account/create/', params);
            if (response.status == 1) {
                this.externalAccountId = response.accountId;
                this.modalS3Visible = false;
                this.s3Success = true;
                this.isProcessing = false;
                flashMessenger.toastById('EXT_ACC_CREATED', 'success');
                if(router.currentRoute.value['name'] === 'account.externalaccount.filestorage') {
                    router.push({name: 'account.externalaccount.filestorage', query: {id: response.accountId}});
                }
            } else {
                flashMessenger.toastById(response.error, 'danger');
                this.isProcessing = false;
            }

        } else {
            this.isProcessing = false;
            return false;
        }
    }
    public editS3(externalAccount) {
        this.clearS3();
        this.externalAccountId = externalAccount['accountId'];
        const externalAccountConfig = externalAccount.config;
        this.s3AuthType = externalAccountConfig.auth_type !== undefined && externalAccountConfig.auth_type ? externalAccountConfig.auth_type : 'pool_id';
        if (this.s3AuthType == 'pool_id') {
            this.identityPoolId = externalAccountConfig.identity_pool_id;
        } else {
            this.accessKey = externalAccountConfig.access_key_id;
            this.secretToken = externalAccountConfig.secret_access_key;
        }
        this.region = externalAccountConfig.region;
        this.bucketname = externalAccountConfig.bucket_name;
        this.modalS3Visible = true;
        this.modalVisible = false;
        this.s3Success = false;
    }
    public async doEditS3() {
        if (this.isProcessing) {
            return;
        }
        this.isProcessing = true;
        const params = this.getS3Params();
        if (params) {
            params['externalAccountId'] = this.externalAccountId;
            let response = await crApi.requestV2('external_account/update/', params);
            if (response.status == 1) {
                //this.externalAccountId = response.accountId;
                this.modalS3Visible = false;
                this.s3Success = true;
                this.isProcessing = false;
                flashMessenger.toastById('EXT_ACC_UPDATED', 'success');
                if(router.currentRoute.value['name'] === 'account.externalaccount.filestorage') {
                    router.go(0)
                    //router.push({name: 'account.externalaccount', query: {id: this.externalAccountId}});
                }
            } else {
                flashMessenger.toastById(response.error, 'danger');
                this.isProcessing = false;
            }


        } else {
            this.isProcessing = false;
            return false;
        }
    }
    public async reauthorizeDropbox(externalAccountId) {
        let authParam = {
            website_token : securityService.getToken(),
            externalAccountId :externalAccountId
        };
        let response = await crApi.requestV2('external_account/dropbox_auth_url/',authParam);
        const authUrl = response.authUrl;
        let state = JSON.stringify({'return_state': router.currentRoute.value['name'], 'return_state_params': router.currentRoute.value['params'], 'return_state_query': router.currentRoute.value['query'], 'externalAccountId': externalAccountId, 'reauthorize': true});

        state =  encodeURIComponent(state);
        // @ts-ignore
        window.location = authUrl+'&state='+state;
    }

    public async reauthorizeGoogle(externalAccountId) {

        let authParam = {
            website_token : securityService.getToken(),
            externalAccountId :externalAccountId
        };
        let response = await crApi.requestV2('external_account/google_auth_url/',authParam);

        const authUrl = response.authUrl;
        let  state ='return_state='+router.currentRoute.value['name']+'&return_state_params='+JSON.stringify(router.currentRoute.value['params'])+'&return_state_query='+JSON.stringify(router.currentRoute.value['query'])+'&externalAccountId='+externalAccountId;
        state += '&reauthorize=1';

        state =  encodeURIComponent(state);
        // @ts-ignore
        window.location = authUrl+'&state='+state;
    }
    public async reauthorizeBox(externalAccountId) {

        let authParam = {
            website_token : securityService.getToken(),
            externalAccountId :externalAccountId
        };
        let response = await crApi.requestV2('external_account/box_auth_url/',authParam);
        const authUrl = response.authUrl;
        let  state ='return_state='+router.currentRoute.value['name']+'&return_state_params='+JSON.stringify(router.currentRoute.value['params'])+'&return_state_query='+JSON.stringify(router.currentRoute.value['query'])+'&externalAccountId='+externalAccountId;
        state += '&reauthorize=1';

        state =  encodeURIComponent(state);
        // @ts-ignore
        window.location = authUrl+'&state='+state;
    }
}

export default new ExternalAccountHelper();
